export default {
	chat: "Chat",
	do_you_confirm_your_registration_for_the_webinar: "¿Confirma su registro para el seminario web {title}?",
	do_you_confirm_your_unsubscription_to_the_webinar: "¿Confirmas tu baja al seminario web {title}?",
	external_link: "Enlace externo",
	join_webinar: "Únase al seminario web",
	live: "En vivo",
	loading_webinars: "Cargando webinars",
	next: "Próximo",
	no_webinars_are_available_at_the_moment: "Actualmente no hay webinars disponibles",
	no_webinars_are_available_with_the_selected_filter: "No hay webinars disponibles para el filtro seleccionado.",
	receive_emails_about_this_webinar: "Reciba correos electrónicos sobre este seminario web",
	register_for_the_webinar: "Regístrese para el seminario web",
	subscribe: "Registrarse",
	subscribed: "Registrado",
	successfully_signed_up_for_the_webinar: "Se inscribió con éxito en el seminario web",
	transmission_date: "Fecha de transmisión",
	transmission_finished: "Transmisión terminada",
	unsubscribe_from_the_webinar: "Cancelar inscripción del seminario web",
	unsubscribe_successfully_for_the_webinar: "Cancelar inscripción con éxito para el seminario web",
	unsubscribe: "Cancelar inscripción",
	watch: "Mirar",
	webinar_offline: "Seminario web sin conexión",
	write_your_question: "Escribe tu pregunta",
	your_message_has_been_received_and_is_awaiting_moderation: "Su mensaje ha sido recibido y está esperando moderación.",
	your_message_has_been_received: "Tu mensaje ha sido recibido",
	your_webinar_will_start_soon_please_wait: "Su seminario web comenzará pronto, por favor espere",
	cert_requirement: "Para la certificación en el seminario web, es necesario un {min_watch_time_percentage}% de permanencia en la primera actividad.",
	fail_message: "¡Lamentablemente reprobaste! Tu permanencia en este seminario web fue del {webcast_user_session_percentage}% y debías permanecer el {min_watch_time_percentage}%.",
}